<div class="font-bold mb-3" i18n>
  When user's device power on or recovers from out-of-coverage, which of the following options do you want the device to register on?
</div>
<div class="ml-6">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="lastRegisteredPLMN"
          inputId="lastRegisteredPLMN#1"
          value="1"
          [(ngModel)]="profileValues.lastRegisteredPLMN"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="lastRegisteredPLMN#1" i18n>Last Registered PLMN</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="lastRegisteredPLMN"
          inputId="lastRegisteredPLMN#2"
          value="2"
          [(ngModel)]="profileValues.lastRegisteredPLMN"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="lastRegisteredPLMN#2" i18n>Home PLMN</label>
      </td>
    </tr>
  </table>
</div>
